import { useEffect, useState } from "react";
import styles from "./prospectListView.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { TableLoader } from "../../../components/LoaderC";
import moment from "moment";
import { Button } from "react-bootstrap";
import { Dialog, MenuItem, Menu, DialogTitle, DialogContent, DialogContentText, DialogActions, Snackbar, IconButton, Slide } from "@mui/material";
import { Typography } from "@material-ui/core";
import dayjs from "dayjs";
import { ChevronDown, Home, X } from "react-feather";
import { toast } from "react-smart-toaster";
import { Link } from "react-router-dom";
import ListFilters from "./components/ListFilters";
import ListRecords from "./components/ListRecords";
import ListDonutWidget from "./components/ListDonutWidget";
import StepOneForm from "../Components/AddProspect/StepOneForm";
import StepTwoForm from "../Components/AddProspect/StepTwoForm";
import StepThreeForm from "../Components/AddProspect/StepThreeForm";
import Loader from "../../../components/Loader";
import { AddLogCallAPI } from "../../../components/AddLogs";
import { useDispatch, useSelector } from "react-redux";
import { communicationChatReload } from "../../../redux/actions/communicationChatRloadAction";
import PeoplePageTitle from "../../tenants/components/PeoplePageTitle";
import { communicationVoiceCallScreenOpen } from "../../../redux/actions/communicationVoiceCallScreenAction";
import { setVoiceCallInfo } from "../../../redux/actions/communicationVoiceCallInfo";
import InfiniteScroll from "react-infinite-scroller";


const ProspectListView = ({ handleView, history, match, type }) => {
  const voiceCallInfo = useSelector((store) => store.communicationVoiceCallInfoReducer);
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const [contentLoading, setContentLoading] = useState(true);
  const [filterOpen, setFilterOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [prospectList, setProspectList] = useState([]);
  const [prospectFilteredList, setFilteredProspectList] = useState([]);
  const [currentFilterValue, setCurrentFilterValue] = useState("prospect");
  const [totalCount, setTotalCount] = useState(0);
  const [filterData, setFilterData] = useState({ property: "", view: "", submitted_at: null, prospect: ['applied', 'not_applied', 'screened', 'approved', 'declined'], credit: "", income: "", notes: type ? type : "", perPage: 20 });
  const [searchKey, setSearchKey] = useState("");
  const [propertyList, setPropertyList] = useState([]);
  const [donutGraphData, setDonutGraphData] = useState([]);
  const [addCustomCredit, setAddCustomCredit] = useState(false);
  const [addCustomSalary, setAddCustomSalary] = useState(false);
  const [creditFilterData, setCreditFilterData] = useState(null);
  const [salaryFilterData, setSalaryFilterData] = useState(null);
  const [salaryFilterOpen, setSalaryFilterOpen] = useState(false);
  const [salaryFilterDefaultOpen, setSalaryFilterDefaultOpen] = useState(false);
  const [creditFilterOpen, setCreditFilterOpen] = useState(false);
  const [creditFilterDefaultOpen, setCreditFilterDefaultOpen] = useState(false);
  const [openAddProspectModal, setOpenAddProspectModal] = useState(false);
  const [addFormStep, setAddFormStep] = useState(1);
  const [stepOneData, setStepOneData] = useState(null);
  const [stepTwoData, setStepTwoData] = useState(null);
  const [openCallModal, setOpenCallModal] = useState(false);
  const [prospectInfoObj, setProspectInfoObj] = useState(null);
  const [isFirstTimeLoading, setIsFirstTimeLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [sortItem, setSortItem] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchAllProperties = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      await axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        let propertyData = response.data.data;

        propertyData = [{ value: "all", label: "All", apartments: [] }].concat(propertyData);
        setPropertyList(propertyData);
      });
    };
    fetchAllProperties();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    setPage(0);
  }, [filterData, creditFilterData, salaryFilterData, searchKey, sortItem, sortOrder]);

  useEffect(() => {
    fetchProspectInChunk(page);
  }, [page, filterData, creditFilterData, salaryFilterData, searchKey, sortItem, sortOrder]);

  const fetchProspectInChunk = async (pageT) => {
    let { submitted_at, property, prospect, credit, income, notes, perPage } = filterData;

    if (credit === "l_than") {
      credit = "0,649";
    } else if (credit === "g_than") {
      credit = "650,0";
    } else if (credit === "custom" && creditFilterData) {
      credit = `${creditFilterData.min},${creditFilterData.max}`;
    }

    if (income === "b_20") {
      income = "0,20000";
    } else if (income === "20_b_40") {
      income = "20000,40000";
    } else if (income === "40_b_60") {
      income = "40000,60000";
    } else if (income === "60_b_80") {
      income = "60000,80000";
    } else if (income === "a_80") {
      income = "80000,0";
    } else if (income === "custom" && salaryFilterData) {
      const min = parseInt(salaryFilterData.min.toString().replace(/,/g, ""), 10);
      const max = parseInt(salaryFilterData.max.toString().replace(/,/g, ""), 10);
      income = `${min},${max}`;
    }

    if (submitted_at && Array.isArray(submitted_at) && submitted_at.length === 2) {
      const start = moment(submitted_at[0]).format("YYYY-MM-DD");
      const end = moment(submitted_at[1]).format("YYYY-MM-DD");
      submitted_at = `${start},${end}`;
    } else {
      submitted_at = '';
    }

    const queryParams = new URLSearchParams();
    queryParams.append("page", pageT);
    queryParams.append("perPage", perPage);
    queryParams.append("searchKey", searchKey);
    queryParams.append("submitted_at", submitted_at);
    queryParams.append("property", property);
    queryParams.append("prospect", prospect.join());
    queryParams.append("credit", credit);
    queryParams.append("notes", notes);
    queryParams.append("income", income);
    queryParams.append("sortItem", sortItem);
    queryParams.append("sortOrder", sortOrder);

    if (isFirstTimeLoading) {
      setContentLoading(true);
      setIsFirstTimeLoading(false);
    }

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    await axios.get(`${process.env.REACT_APP_APPLICANT_API_URL}v1/prospect-follow-ups?${queryParams.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setContentLoading(false);

      setTotalCount(response.data.total);
      if (page === 0) {
        setFilteredProspectList(response.data.data);
      } else {
        if (response.data.data?.length > 0) {
          setFilteredProspectList(prev => {
            return prev.concat(response.data.data);
          });
        }
      }
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setContentLoading(false);
    });
  }

  /*useEffect(() => {
    getDonutGraphData("");
  }, [getAccessTokenSilently]);*/

  useEffect(() => {
    const buildUrl = () => {
      if (currentFilterValue === "search" || currentFilterValue === "credit" || currentFilterValue === "income")
        return;
      const queryParams = [];

      queryParams.push(`current_status=${filterData.prospect.join()}`);

      if (filterData.property && filterData.property !== "all") {
        queryParams.push(`property_id=${filterData.property}`);
      }

      if (filterData.notes && filterData.notes !== "all") {
        queryParams.push(`follow_up=${filterData.notes}`);
      }

      if (Array.isArray(filterData.submitted_at) && filterData.submitted_at.length === 2) {
        const start = filterData.submitted_at[0]?.toLocaleDateString("en-CA");
        const end = filterData.submitted_at[1]?.toLocaleDateString("en-CA");

        queryParams.push(`start=${start}`);
        queryParams.push(`end=${end}`);
      }

      let queryParamsUrl = "";

      if (queryParams.length) {
        queryParamsUrl = `?${queryParams.join("&")}`;
      }

      getDonutGraphData(queryParamsUrl);
    }

    console.log('currentFilterValue');
    console.log(currentFilterValue);

    if (currentFilterValue) {
      buildUrl();
    }
  }, [currentFilterValue, filterData]);

  async function getDonutGraphData(queryParams) {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    let url = process.env.REACT_APP_APPLICANT_API_URL + "v1/followup-widget-data";

    if (queryParams) {
      url = url + queryParams;
    }
    axios(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setDonutGraphData(response.data.data);
    }).catch((error) => { });
  }

  const onSubmitOne = (data) => {
    setAddFormStep(2);
    setStepOneData(data);
  };

  const onSubmitTwo = (data) => {
    let cData = {};
    if (typeof data.credit_score !== "undefined") {
      cData = { ...cData, credit_score: data.credit_score };
    }
    if (typeof data.have_pets !== "undefined") {
      cData = { ...cData, have_pets: data.have_pets };
    }
    if (typeof data.income_per_year !== "undefined") {
      cData = { ...cData, income_per_year: data.income_per_year };
    }
    if (typeof data.bedrooms !== "undefined") {
      cData = { ...cData, bedrooms: data.bedrooms };
    }
    if (typeof data.move_in_date !== "undefined") {
      cData = { ...cData, move_in_date: dayjs(data?.move_in_date).format("YYYY-MM-DD HH:mm:ss") };
    }
    if (typeof data.bathrooms !== "undefined") {
      cData = { ...cData, bathrooms: data.bathrooms };
    }
    if (typeof data.do_you_smoke !== "undefined") {
      cData = { ...cData, do_you_smoke: data.do_you_smoke };
    }
    if (typeof data.is_tour !== "undefined") {
      cData = { ...cData, is_tour: data.is_tour };
    }

    setAddFormStep(3);
    setStepTwoData(cData);
  }

  const onAddProspectSubmit = async (data) => {
    let postData = {};
    let is_tour = false;
    postData = { ...postData, ...stepOneData, ...stepTwoData };
    if (addFormStep === 2) {
      if (typeof data.credit_score !== "undefined") {
        postData = { ...postData, credit_score: data.credit_score };
      }
      if (typeof data.have_pets !== "undefined") {
        postData = { ...postData, have_pets: data.have_pets };
      }
      if (typeof data.income_per_year !== "undefined") {
        postData = { ...postData, income_per_year: data.income_per_year };
      }
      if (typeof data.bedrooms !== "undefined") {
        postData = { ...postData, bedrooms: data.bedrooms };
      }
      if (typeof data.move_in_date !== "undefined") {
        postData = { ...postData, move_in_date: dayjs(data?.move_in_date).format("YYYY-MM-DD HH:mm:ss") };
      }
      if (typeof data.bathrooms !== "undefined") {
        postData = { ...postData, bathrooms: data.bathrooms };
      }
      if (typeof data.do_you_smoke !== "undefined") {
        postData = { ...postData, do_you_smoke: data.do_you_smoke };
      }
    }

    if (typeof postData.is_tour !== "undefined") {
      is_tour = postData.is_tour;
    }

    if (typeof data.tour_date_time !== "undefined") {
      postData = { ...postData, tour_date_time: data.tour_date_time };
    }

    setOpenAddProspectModal(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    await axios.post(process.env.REACT_APP_APPLICANT_API_URL + "v1/add-prospect", postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);
      dispatch(communicationChatReload(true));
      let prospectListTemp = prospectList;
      prospectListTemp = [response.data.data].concat(prospectListTemp);

      setProspectList(prospectListTemp);

      let logData = {
        title: "A new prospect is added",
        description: [
          "Name: " + response?.data?.data?.full_name,
          "Phone: " + response?.data?.data?.phone,
          "Property: " + response?.data?.data?.property_name,
          "Apartment: " + response?.data?.data?.apt_no,
        ],
      };
      AddLogCallAPI(logData, token);

      if (is_tour) {
        let logData = {
          title: "A new prospect tour is added",
          description: [
            "Name: " + response?.data?.data?.full_name,
            "Phone: " + response?.data?.data?.phone,
            "Property: " + response?.data?.data?.property_name,
            "Date/Time: " +
            moment(data.tour_date_time).format("MM/DD/YYYY hh:mm a"),
          ],
        };
        AddLogCallAPI(logData, token);
      }
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        setSnackbarMsg(error.response.data.message);
      setSnackbarOpen(true);
    });
  }

  const onSubmitCreditFiler = (data) => {
    setAddCustomCredit(false);
    setCreditFilterData(data);
    setCreditFilterOpen(false);
  };

  const onSubmitSalaryFiler = (data) => {
    setAddCustomSalary(false);
    setSalaryFilterData(data);
    setSalaryFilterOpen(false);
  };

  useEffect(() => {
    if (filterData?.credit === "custom" && creditFilterDefaultOpen) {
      setCreditFilterOpen(true);
    }
  }, [filterData?.credit, creditFilterDefaultOpen]);

  useEffect(() => {
    if (filterData?.income === "custom" && salaryFilterDefaultOpen) {
      setSalaryFilterOpen(true);
    }
  }, [filterData?.income, salaryFilterDefaultOpen]);

  const initiateVoiceCall = (item) => {
    if (voiceCallInfo) {
      toast.error("You are on anotehr call.");
    } else {
      setOpenCallModal(true);
      setProspectInfoObj(item);
    }
  }

  const initiateVoiceCallConfirm = () => {
    setOpenCallModal(false);
    let newProspectInfo = {
      id: prospectInfoObj?.id,
      full_name: prospectInfoObj?.full_name,
      initial: prospectInfoObj?.initial,
      phone: prospectInfoObj?.phone,
      user_avatar: prospectInfoObj?.user_avatar,
    };
    dispatch(communicationVoiceCallScreenOpen(true));
    dispatch(setVoiceCallInfo(newProspectInfo));
  }

  return (<div>
    <div className={`${styles.pageTitleWrap}`}>
      <div className={`${styles.PageMainTTSec}`}>
        <PeoplePageTitle defaultPage={"Prospects"} />
        <Typography display="inline" className={`${styles.pageTitle} ${styles.Small}`} onClick={(e) => { e.preventDefault(); setAnchorEl(e.currentTarget); }}>Prospects <ChevronDown /></Typography>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={(e) => {
            e.preventDefault();
            setAnchorEl(null);
          }}
          MenuListProps={{ "aria-labelledby": "basic-button" }}
        >
          <MenuItem className={`${styles.DropdownPageTitleMenu}`}>
            <Link to="/people/prospects">Prospect</Link>
          </MenuItem>
          <MenuItem className={`${styles.DropdownPageTitleMenu}`}>
            <Link to="/people/leaderboards">Leaderboard</Link>
          </MenuItem>
        </Menu>
        {totalCount > 0 && (<p className={`${styles.CountText}`}>({totalCount} Prospects)</p>)}
      </div>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>People</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>Prospects</li>
        </ol>
      </nav>
    </div>

    <div className={`${styles.BodyCon}`}>
      {loading && <Loader />}

      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          <div className="control-pane">
            {contentLoading && (<div className="Loader TableLoader">
              <TableLoader />
            </div>)}

            <div className={`${styles.Row}`}>
              {!contentLoading && (<>
                <ListFilters
                  setFilterData={setFilterData}
                  setSearchKey={setSearchKey.bind(this)}
                  setFilterOpen={setFilterOpen}
                  filterOpen={filterOpen}
                  filterData={filterData}
                  propertyList={propertyList}
                  handleView={handleView}
                  setCurrentFilterValue={setCurrentFilterValue}
                  setAddFormStep={setAddFormStep}
                  setOpenAddProspectModal={setOpenAddProspectModal}
                  isAuthenticated={isAuthenticated}
                  user={user}
                  setCreditFilterData={setCreditFilterData}
                  setCreditFilterOpen={setCreditFilterOpen}
                  setAddCustomCredit={setAddCustomCredit}
                  onSubmitCreditFiler={onSubmitCreditFiler}
                  addCustomCredit={addCustomCredit}
                  creditFilterData={creditFilterData}
                  setCreditFilterDefaultOpen={setCreditFilterDefaultOpen}
                  creditFilterOpen={creditFilterOpen}
                  setSalaryFilterData={setSalaryFilterData}
                  setSalaryFilterOpen={setSalaryFilterOpen}
                  salaryFilterOpen={salaryFilterOpen}
                  setAddCustomSalary={setAddCustomSalary}
                  onSubmitSalaryFiler={onSubmitSalaryFiler}
                  addCustomSalary={addCustomSalary}
                  salaryFilterData={salaryFilterData}
                  setSalaryFilterDefaultOpen={setSalaryFilterDefaultOpen}
                />

                <div className={`${styles.IncomeListingBody}`}>
                  <div className={`${styles.IncomeListSec}`}>
                    {prospectFilteredList.length > 0 && (<InfiniteScroll
                      pageStart={0}
                      initialLoad={false}
                      loadMore={(e) => {
                        const nextPage = page + 1;
                        setPage(nextPage);
                      }}
                      hasMore={prospectFilteredList?.length < totalCount}
                      loader={<div className={`${styles.CSSLoaderSec}`} key={0}>
                        <span className={`${styles.CSSCuatomLoader}`}></span>
                        <p>Loading...</p>
                      </div>}
                    >
                      <ListRecords
                        filterredData={prospectFilteredList}
                        initiateVoiceCall={initiateVoiceCall}
                        history={history}
                        sortItem={sortItem}
                        sortOrder={sortOrder}
                        setSortItem={setSortItem.bind(this)}
                        setSortOrder={setSortOrder.bind(this)}
                      />
                    </InfiniteScroll>)}

                    {prospectFilteredList.length === 0 && (
                      <div className={`${styles.NoDataMain}`}>
                        <div className={`${styles.NoDataIMG}`}>
                          <img src="/static/img/no-prospect.png" alt="No Data" />
                        </div>
                        <p className={`${styles.NoDataText}`}>Let's get started!</p>
                        <p className={`${styles.NoDataTextSub}`}>Prospect List is Currently Empty.</p>
                      </div>
                    )}
                  </div>

                  <div className={`${styles.IncomeGraphSec}`}>
                    <ListDonutWidget donutGraphData={donutGraphData} no_of_prospect={prospectFilteredList.length} />
                  </div>
                </div>
              </>)}
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={openAddProspectModal}
        fullWidth
        maxWidth="sm"
        onClose={(e) => { setOpenAddProspectModal(false); }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp CustomWidthPopUs"
      >
        {addFormStep === 1 && (<StepOneForm setOpenAddProspectModal={setOpenAddProspectModal.bind(this)} onSave={onSubmitOne.bind(this)} selectedProperty={0} />)}
        {addFormStep === 2 && (<StepTwoForm setOpenAddProspectModal={setOpenAddProspectModal.bind(this)} onSave={onSubmitTwo.bind(this)} onSubmit={onAddProspectSubmit.bind(this)} isTourOption={true} />)}
        {addFormStep === 3 && (<StepThreeForm setOpenAddProspectModal={setOpenAddProspectModal.bind(this)} onSubmit={onAddProspectSubmit.bind(this)} prospect_name={stepOneData?.prospect_name} property_id={stepOneData?.property_id} />)}
      </Dialog>

      <Dialog
        open={openCallModal}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setOpenCallModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">
          Prospect Call Confirmation
          <button onClick={(e) => setOpenCallModal(false)}><X /></button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">Please confirm you wish to initiate a call to this prospect.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => setOpenCallModal(false)} className="CancelPopupBU">Cancel</Button>
          <Button onClick={(e) => initiateVoiceCallConfirm()} className="SubmitPopupBU">Proceed</Button>
        </DialogActions>
      </Dialog>
    </div>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />
  </div>);
};

export default ProspectListView;